import { StateToken } from '@ngxs/store';
import {
  FieldMeta,
  PageData,
  PageResultDto,
  SearchableField,
} from '../../../../shared/utils/utils.types';
import { ApplyCandidateCvSS, ApplyCvData, LyaCvDetail, LyaCvMeta } from '../lya-cv.types';
import { PostOfferApplyMeta } from '../post-offer.types';

export interface LyaCvStateModel {
  currentPage: PageData | null;
  cvsPage: PageResultDto<LyaCvMeta> | null;
  cvDetail: LyaCvDetail | null;
  appliesPage: PageResultDto<PostOfferApplyMeta> | null;
  offerApplyMeta: PostOfferApplyMeta | null;
  applyData: ApplyCvData | null;
  applyCandidateCvSS: ApplyCandidateCvSS[];
  loadingApplyCandidateCvss: boolean;
  declaredFields: FieldMeta[];
  searchableFields: SearchableField[];
  persistVectorSearchHistory: string[];
}

export const LYA_CV_STATE_TOKEN = new StateToken<LyaCvStateModel>('lyaCvState');

const CVS_SEARCHABLE_FIELDS: SearchableField[] = [
  { id: 'title', type: 'string', accept: 'text' },
  { id: 'email', type: 'string', accept: 'text' },
  { id: 'phoneNumber', type: 'string', accept: 'text' },
  { id: 'firstName', type: 'string', accept: 'text' },
  { id: 'lastName', type: 'string', accept: 'text' },
  { id: 'aliasName', type: 'string', accept: 'text' },
  { id: 'presentation', type: 'string', accept: 'text' },
  /*{ id: 'cvLanguage', type: 'string', accept: 'text' },
  { id: 'presentation', type: 'string', accept: 'text' },
  { id: 'notes', type: 'string', accept: 'list:text' },
  { id: 'formations', type: 'string', accept: 'list:text' },
  { id: 'skills', type: 'string', accept: 'list:text' },
  { id: 'experiences', type: 'string', accept: 'list:text' },
  { id: 'certificates', type: 'string', accept: 'list:text' },
  { id: 'languages', type: 'string', accept: 'text' },
  { id: 'experienceYears', type: 'string', accept: 'number' },
  { id: 'createdAt', type: 'string', accept: 'text' },
  { id: 'updatedAt', type: 'string', accept: 'text' },*/
];

export const INITIAL_LYA_CV_STATE: LyaCvStateModel = {
  currentPage: null,
  cvsPage: null,
  cvDetail: null,
  appliesPage: null,
  offerApplyMeta: null,
  applyData: null,
  applyCandidateCvSS: [],
  loadingApplyCandidateCvss: false,
  declaredFields: [],
  searchableFields: CVS_SEARCHABLE_FIELDS,
  persistVectorSearchHistory: [],
};
export const LYACV_STORAGE_KEYS = [`${LYA_CV_STATE_TOKEN.getName()}.persistVectorSearchHistory`];
